import { useEffect, useState } from "react";
import HttpClient from "../helpers/HttpClient";

export const useElectronicDataRequests = () => {
  const [electronicDataRequests, setElectronicDataRequests] = useState<any[]>([]);
  const [electronicDataRequestsLoading, setElectronicDataRequestsLoading] = useState<boolean>(true);

  const fetchElectronicDataRequests = () => {
    setElectronicDataRequestsLoading(true);
    HttpClient({
      url: `/v2/electronic-data-requests`,
      method: "get",
    })
      .then((res: any) => {
        setElectronicDataRequests(res.data.data);
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setElectronicDataRequestsLoading(false);
      });
  };

  useEffect(() => {
    fetchElectronicDataRequests();
  }, []);

  return {
    electronicDataRequests,
    electronicDataRequestsLoading,
    fetchElectronicDataRequests,
  };
};
